import { define, announce } from './theme.js';

class FacetFilters extends HTMLElement {
  connectedCallback() {
    this.setAttribute('data-enhanced', '');
    this.life = new AbortController();
    const options = { signal: this.life.signal };
    this.addEventListener('submit', event => {
      if (!event.target.matches('[data-facet-form]')) return;
      event.preventDefault();
      const form = event.target;
      const url = new URL(form.action);
      for (const [key, value] of new FormData(form)) if (value !== '') url.searchParams.append(key, value);
      this.closePanel();
      this.load(url);
    }, options);
    this.addEventListener('change', event => {
      if (event.target.matches('[name="sort_by"]')) event.target.form.requestSubmit();
    }, options);
    this.addEventListener('click', event => {
      if (event.target.closest('[data-facet-close]')) this.closePanel();
      const summary = event.target.closest('[data-facet-disclosure] > summary');
      if (summary && matchMedia('(max-width: 749px)').matches) {
        event.preventDefault();
        this.openPanel(summary);
      }
      const link = event.target.closest('[data-facet-link], .pagination a');
      if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      event.preventDefault();
      this.load(new URL(link.href));
    }, options);
    window.addEventListener('popstate', () => this.load(new URL(location.href), false), options);
  }
  disconnectedCallback() { this.removeAttribute('data-enhanced'); this.closePanel(); this.life.abort(); this.request?.abort(); }
  openPanel(trigger) {
    if (this.dialog) return;
    this.trigger = trigger;
    this.panel = this.querySelector('[data-facet-panel]');
    this.panelHome = this.panel.parentElement;
    this.dialog = document.createElement('dialog');
    this.dialog.className = 'facets__dialog';
    this.dialog.setAttribute('scroll-lock', '');
    this.dialog.setAttribute('aria-label', trigger.textContent.trim());
    this.querySelector('[data-facet-form]').append(this.dialog);
    this.dialog.append(this.panel);
    this.panel.querySelector('[data-facet-close]').hidden = false;
    this.dialog.addEventListener('close', () => this.closePanel(), { once: true });
    this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.closePanel(); });
    this.dialog.showModal();
  }
  closePanel() {
    if (!this.dialog) return;
    const dialog = this.dialog;
    this.dialog = null;
    dialog.close();
    this.panelHome.append(this.panel);
    this.panel.querySelector('[data-facet-close]').hidden = true;
    dialog.remove();
    if (this.trigger?.isConnected) this.trigger.focus({ preventScroll: true });
  }
  async load(url, push = true) {
    this.request?.abort();
    const request = this.request = new AbortController();
    const requestUrl = new URL(url);
    requestUrl.searchParams.set('section_id', this.dataset.sectionId);
    this.setAttribute('aria-busy', 'true');
    const focused = document.activeElement?.id;
    try {
      const response = await fetch(requestUrl, { signal: request.signal });
      if (!response.ok) throw new Error('Filter request failed');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const next = doc.getElementById(this.id);
      if (!next) throw new Error('Missing filter section');
      if (request.signal.aborted) return;
      this.closePanel();
      this.innerHTML = next.innerHTML;
      this.querySelectorAll('script[type="module"][src]').forEach(script => {
        const active = document.createElement('script'); active.type = 'module'; active.src = script.src; script.replaceWith(active);
      });
      if (push) history.pushState({}, '', url);
      const status = this.querySelector('[data-facet-count]');
      announce(status?.textContent.trim() || '');
      const target = focused && this.querySelector(`#${CSS.escape(focused)}`);
      (target || status)?.focus({ preventScroll: true });
    } catch (error) {
      if (error.name !== 'AbortError') location.assign(url);
    } finally { if (this.request === request) this.removeAttribute('aria-busy'); }
  }
}
define('facet-filters', FacetFilters);
